import type { AnonymousUser, User, Whoami } from '@iheartjane/data-access';
import type { Nullable } from '@iheartjane/types';

export type UserResponse = {
  jwtToken: string;
  refreshToken?: string;
};

export interface UserIdentity extends UserResponse, Whoami {}

export const isJaneUser = (user?: User | AnonymousUser): user is User =>
  !!user?.authenticated;

export interface OAuthUser extends User {
  new_oauth: Nullable<boolean>;
  new_registration: Nullable<boolean>;
}
